import Image from "@Components/Image";
import styles from "./ListWithUsCard.module.scss";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import wrapperHOC from "@Utils/wrapperHOC";
import useCustomWindowOpen from "@Components/CustomWindowOpen";
import Button from "@Components/Button";

const ListWithUsCard = ({
  title,
  actualCta,
  subtitle,
  ctaText,
  href,
  isDesktop = false,
  imgUrl = null,
}: any) => {
  const customWindowOpen = useCustomWindowOpen();
  const handleClick = () => {
    gtagEventEmitter({
      action: `${
        actualCta == "Partner With Us"
          ? "partner_with_us_card_clicked"
          : "list_with_us_card_clicked"
      }`,
    });
    customWindowOpen({ url: href, target: "_blank", isExternal: true });
  };
  return (
    <div
      onClick={handleClick}
      role="none"
      key={title}
      className={formatClassNames(
        styles.lwsCardContainer,
        isDesktop && styles.lwsCardContainerDesktop,
      )}
    >
      <div className={styles.content} data-testid={`${title}-banner`}>
        <Image src={imgUrl} height="100%" width="100%" alt={title} />
        <div>
          <h2 className={styles.lwsTitle}>{title}</h2>
          <div className={styles.lwsSubtitle}>{subtitle}</div>
        </div>
        <Button
          type="button"
          variant="none"
          size="md"
          className={styles.lwsCta}
          data-testid={`${title}-button`}
        >
          <span className={styles.lwsCtaText}>{ctaText}</span>
        </Button>
      </div>
    </div>
  );
};

export default wrapperHOC(ListWithUsCard, {
  componentName: "ListWithUsCard-ListWithUs-Home",
  showForChina: true,
});
